import $ from 'jquery';
import debounce from '../utility/debounce';

const imageSizes = [ 400, 650, 700, 900, 1024, 1150]; // CHANGE: TINE FIX rmove 1400

let $imgs;
let winWidth;

function getClosestSize(size){
    const goal = size;
    let closest = null;
    $.each(imageSizes, function(){
        if (closest == null || Math.abs(this - goal) < Math.abs(closest - goal)) {
            closest = this;
        }
    });
    return closest;
}

function checkParentSize(img){
    const $img = img;
    const parent = $($img.parent());

    const minSize = parent.data('minsize');
    if (minSize && minSize >= parent.width() ){
        return minSize;
    }

    const size = getClosestSize(parent.width());
    return size;
}

function swapImage($img, size){
    let url = $img.data('src');
    $img.attr('data-size', size);

    const local = !url.indexOf('192.168');
    if (local){
        url = 'http://' + url;
    }

    const seperator = (url.indexOf('?') === -1) ? '?' : '&';
    // If we decide to use any other parameter that is available in Sitecore,
    // then we will have to take these into account when constructing the url.
    $img.attr('src', url + seperator + 'width=' + size);
}

function resizeHandler(){
    winWidth = $(window).width();

    $imgs.each(function(i, el) {
        const $img = $(el);
        const size = checkParentSize($img);
        if (size != $img.attr('data-size')){
            swapImage($img, size);
        }
    });
}

function init() {
    if ($('.sc-editmode').length > 0) return;

    //portrait gallery ugly escape
    $imgs = $('.centered-image img[data-src]').not('.article-gallery--portrait .centered-image img[data-src]');
    $(window).resize( debounce(resizeHandler, 300) );
    resizeHandler();
}


export default {
    init: init,
    checkParentSize: checkParentSize,
    getClosestSize: getClosestSize
};
